import styled from '@emotion/styled';
import { Grid } from '@mui/material';
export const GridWrap = styled(Grid)(({ marginTop = '5px' }) => ({
  marginTop: marginTop,
}));
